<template>
    <div class="ds-pricing-card card">
        <div v-if="isPending && !hasPricing" class="ds-pricing-card--pending p--m icon-text">
            <icon name="spinner" size="xs" color="primary" spin />
            <span class="ts--body-small color--grey-700">
                {{ $t('search-page.message.loading') }}
            </span>
        </div>
        <div
            v-else-if="isPending || hasPricing"
            :class="`ds-pricing-card__body ds-pricing-card__body--items-${pricingList.length} d--flex`"
        >
            <a
                v-for="(item, i) in pricingList"
                :key="i"
                :href="item.href"
                :title="item.title"
                class="ds-pricing-card__item d--flex items-center p-bottom--xs p-top--xs p-left--m p-right--m"
                @click="handlePriceBoxClick(i + 1, $event)"
            >
                <div
                    class="ds-pricing-card__item-title ts-align--left ts--small ts--uppercase ts-weight--700 color--grey-700"
                    @click="handlePriceLabelClick(item.type)"
                >
                    <slot name="item-title">{{ item.type.text }}</slot>
                </div>
                <div class="ds-pricing-card__item-value ts-align--right color--grey-900">
                    <slot name="item-value" v-bind="{ item }">
                        <template v-if="item.type && item.type.slug && item.type.slug.toLowerCase() === 'listing'">
                            <div>
                                <span>{{ item.prefixMinPrice }}</span>
                                <span class="ts-weight--700 ts--body-small ds-pricing-card__item-price-main">&nbsp;{{ item.minPrice }}</span>
                            </div>
                            <template v-if="item.minPrice !== item.maxPrice">
                                <div class="ts--micro ds-pricing-card__item-price-secondary m-top--xxs">
                                    <span>{{ item.prefixMaxPrice }}</span>
                                    <span class="ds-pricing-card__item-price">&nbsp;{{ item.maxPrice }}</span>
                                </div>
                            </template>
                        </template>
                        <template v-else>
                            <div>
                                <span class="ts-weight--700 ts--body-small ds-pricing-card__item-price-main">{{
                                    item.finalPrice
                                }}</span>
                            </div>
                            <div
                                v-if="item.originalPrice"
                                class="ts--micro ds-pricing-card__item-price-secondary m-top--xxs"
                            >
                                <del>{{ item.originalPrice }}</del>
                            </div>
                        </template>
                    </slot>
                </div>
            </a>
            <div
                v-if="isPending"
                class="ds-pricing-card__item--pending p-bottom--xs p-top--xs p-left--m p-right--m icon-text"
            >
                <icon name="spinner" size="xs" color="primary" spin />
                <span class="ts--body-small color--grey-700">
                    {{ $t('search-page.message.loading') }}
                </span>
            </div>
        </div>
        <div
            v-else-if="!isPending && !hasPricing"
            class="ds-pricing-card__body--no-items p-bottom--s p-top--s p-left--m p-right--m ts-weight--700 color--grey-900 ts--caption"
        >
            {{ $t('ds-pricing-card.no-offers-to-provide') }}
        </div>
        <div
            v-if="!isPending && offersPageUrl"
            class="ds-pricing-card__footer p-top--xs p-bottom--xs p-left--m p-right--m ts-align--center"
        >
            <a
                :href="offersPageUrl"
                class="ds-pricing-card__footer-link ts-link ts-link--primary icon-text"
                @click="handleSeeAllOffersClick"
            >
                <slot name="url-label">
                    <icon name="page-link" size="xs" />
                    <span class="ts--body-small">
                        {{ $t(hasPricing ? 'ds-pricing-card.view-all-offers' : 'ds-pricing-card.view-similar-offers') }}
                    </span>
                </slot>
            </a>
        </div>
    </div>
</template>

<script>
import Icon from '@v4/common/components/atoms/Icon';

/**
 * Pricing card with data polling
 *
 * @version 4.0.0
 * @example ./examples/DsPricingCard.md
 */
export default {
    name: 'DsPricingCard',
    components: {
        Icon,
    },
    props: {
        isPending: {
            type: Boolean,
            default: false,
        },
        pricingList: {
            type: Array,
            default: () => [],
        },
        offersPageUrl: {
            type: String,
            default: '',
        },
    },
    computed: {
        hasPricing() {
            return this.pricingList && this.pricingList.length > 0;
        },
    },
    methods: {
        handleSeeAllOffersClick(event) {
            /**
             * This event is fired when a link to see the all offers is clicked.
             *
             * @event see-all-offers-click
             * @type {undefined}
             */
            this.$emit('see-all-offers-click', null, event);
        },
        handlePriceBoxClick(index, $event) {
            /**
             * This event is fired when a price container box is clicked.
             *
             * @event price-box-click
             * @type {Number}
             */
            this.$emit('price-box-click', index, $event);
        },
        handlePriceLabelClick(type) {
            /**
             * This event is fired when a price label is clicked.
             *
             * @event price-label-click
             * @type {Object}
             */
            this.$emit('price-label-click', type);
        },
    },
};
</script>
